import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { TomaAguaSuperficialSchema } from "../data/TomaAguaSuperficialSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import PointField from "./controls/PointField";
import { isInvalid } from "../utils/forms";
import AmmountField from "./controls/AmmountField";
import SelectField from "./controls/SelectField";
import QuestionField from "./controls/QuestionField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";

export function TomaAguaSuperficialForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  unidadCaudalMedio,
  unidadCaudalPico,
  subcuencas,
  disabled,
}) {
  const { t } = useTranslation();
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={TomaAguaSuperficialSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(tomaAguaSuperficialForm) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("tomaAguaSuperficialForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <PointField
                id="tomaAguaSuperficial_ubicacion"
                name="ubicacion"
                label={t("tomaAguaSuperficial.ubicacion")}
                value={tomaAguaSuperficialForm.values.ubicacion}
                onChange={(event) =>
                  tomaAguaSuperficialForm.handleChange(event)
                }
                isInvalid={isInvalid("ubicacion", tomaAguaSuperficialForm)}
                error={t(tomaAguaSuperficialForm.errors.ubicacion)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <AmmountField
                id="tomaAguaSuperficial_caudalMedio"
                name="caudalMedio"
                label={t("tomaAguaSuperficial.caudalMedio")}
                value={tomaAguaSuperficialForm.values.caudalMedio}
                onChange={(event) =>
                  tomaAguaSuperficialForm.handleChange(event)
                }
                unit={unidadCaudalMedio}
                isInvalid={isInvalid("caudalMedio", tomaAguaSuperficialForm)}
                error={t(tomaAguaSuperficialForm.errors.caudalMedio)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <AmmountField
                id="tomaAguaSuperficial_caudalPico"
                name="caudalPico"
                label={t("tomaAguaSuperficial.caudalPico")}
                value={tomaAguaSuperficialForm.values.caudalPico}
                onChange={(event) =>
                  tomaAguaSuperficialForm.handleChange(event)
                }
                unit={unidadCaudalPico}
                isInvalid={isInvalid("caudalPico", tomaAguaSuperficialForm)}
                error={t(tomaAguaSuperficialForm.errors.caudalPico)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <SelectField
                id="tomaAguaSuperficial_subcuenca"
                name="subcuenca"
                label={t("tomaAguaSuperficial.subcuenca")}
                value={tomaAguaSuperficialForm.values.subcuenca}
                onChange={(event) =>
                  tomaAguaSuperficialForm.handleChange(event)
                }
                options={subcuencas}
                valueAttr="codigo"
                labelAttr="nombre"
                emptyLabel="..."
                isInvalid={isInvalid("subcuenca", tomaAguaSuperficialForm)}
                error={t(tomaAguaSuperficialForm.errors.subcuenca)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <QuestionField
                id="tomaAguaSuperficial_caudalimetroFunciona"
                name="caudalimetroFunciona"
                label={t("tomaAguaSuperficial.caudalimetroFunciona")}
                value={tomaAguaSuperficialForm.values.caudalimetroFunciona}
                onChange={(event) =>
                  tomaAguaSuperficialForm.handleChange(event)
                }
                isInvalid={isInvalid(
                  "caudalimetroFunciona",
                  tomaAguaSuperficialForm,
                )}
                error={t(tomaAguaSuperficialForm.errors.caudalimetroFunciona)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("tomaAguaSuperficialForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("tomaAguaSuperficialForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("tomaAguaSuperficialForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    tomaAguaSuperficialForm.submitForm();
                  }}
                  disabled={disabled}
                />
                {page === -1 && (
                  <Button
                    sm
                    variant="default"
                    value={t("infraestructuraForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
